<template>
  <div
    class="auth-phone"
    :class="{ 'auth-phone--invalid': highlight }"
    dir="ltr"
    @click="focusInput"
  >
    <span
      class="auth-phone__prefix"
      aria-hidden="true"
    >
      +98
    </span>
    <input
      :id="id"
      ref="inputEl"
      :value="display"
      type="tel"
      :name="name"
      inputmode="numeric"
      autocomplete="tel"
      maxlength="13"
      placeholder="912 345 6789"
      class="auth-phone__field"
      v-bind="ariaAttrs"
      @input="onInput"
      @blur="emitFormBlur"
      @focus="emitFormFocus"
      @change="emitFormChange"
    >
    <span
      v-if="complete"
      class="auth-phone__status auth-phone__status--ok"
      aria-hidden="true"
    >
      <UIcon
        name="i-lucide-check"
        class="size-4"
      />
    </span>
    <span
      v-else-if="typedCount > 0"
      class="auth-phone__status"
      aria-hidden="true"
    >
      {{ toFaDigits(typedCount) }} / {{ toFaDigits(10) }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { formatIrMobileNational, isCompleteIrMobile, normalizeIrMobile } from '~/utils/phone'
import { toFaDigits } from '~/utils/faDigits'

const model = defineModel<string>({ default: '' })

const {
  id,
  name,
  highlight,
  ariaAttrs,
  emitFormBlur,
  emitFormInput,
  emitFormChange,
  emitFormFocus,
} = useFormField(undefined, { deferInputValidation: true })

const inputEl = ref<HTMLInputElement | null>(null)

const display = computed(() => formatIrMobileNational(model.value))
const typedCount = computed(() => {
  const digits = model.value.replace(/\D/g, '')
  return model.value.startsWith('0') ? Math.max(0, digits.length - 1) : digits.length
})
const complete = computed(() => isCompleteIrMobile(model.value))

function focusInput() {
  inputEl.value?.focus()
}

function onInput(event: Event) {
  const next = normalizeIrMobile((event.target as HTMLInputElement).value)
  model.value = next
  emitFormInput()
  const el = inputEl.value
  if (!el) return
  const formatted = formatIrMobileNational(next)
  el.value = formatted
  el.setSelectionRange(formatted.length, formatted.length)
}
</script>
